export { useImageBase_unstable as useImage } from '@fluentui/react-image';
